import React from 'react';
import { Link } from 'react-router-dom';
import { isModernApi } from '../../index';

export default props => {
  let docType = <h6>{props.document.docclass_name}</h6>;
  let indexes = (
    <>
      {props.document.indexes &&
        props.document.indexes.length > 0 && (
          <dl>
            {props.document.indexes.map((item, index) => {
              return (
                <div
                  className="row"
                  key={`index_${index}`}
                  style={{ marginBottom: '10px' }}
                >
                  <dt>
                    {item.name}
                    :&nbsp;
                  </dt>
                  <dd style={{ marginBottom: '0' }}>{item.value}</dd>
                </div>
              );
            })}
          </dl>
        )}
    </>
  );

  if (isModernApi()) {
    docType = (
      <>
        {props.document.types.map(typeKey => {
          console.log('typesMap', props.typesMap);
          console.log('typeKey', typeKey);
          return (
            <div key={typeKey}>
              <h6>{props.typesMap[typeKey]}</h6>
              <br />
            </div>
          );
        })}
      </>
    );
    indexes = (
      <dl>
        {Object.keys(props.document.indexes).map(key => {
          let value = props.document.indexes[key];
          if (props.indexesMap[key].type === 'date') {
            const date = new Date(value);
            value =
              (date.getUTCMonth() > 8
                ? date.getUTCMonth() + 1
                : '0' + (date.getUTCMonth() + 1)) +
              '/' +
              (date.getUTCDate() > 9
                ? date.getUTCDate()
                : '0' + date.getUTCDate()) +
              '/' +
              date.getUTCFullYear();
          }
          return (
            <div
              className="row"
              key={`index_${key}`}
              style={{ marginBottom: '10px' }}
            >
              <dt>
                {props.indexesMap[key].description}
                :&nbsp;
              </dt>
              <dd style={{ marginBottom: '0' }}>{value}</dd>
            </div>
          );
        })}
      </dl>
    );
  }
  return (
    <tr>
      <th scope="row">{props.rowCount}.</th>
      <td>
        <Link
          to={`/external/viewer/${props.document.id}${
            isModernApi() ? '?newchive=true' : ''
          }`}
        >
          <img src={`data:image/png;base64,${props.thumb}`} alt="thumb" />
        </Link>
      </td>
      <td>{docType}</td>
      <td>{indexes}</td>
      <td>
        {new Intl.DateTimeFormat('en-US', {
          year: 'numeric',
          month: 'short',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        }).format(
          isModernApi()
            ? new Date(props.document.created)
            : props.document.creationtime
        )}
      </td>
    </tr>
  );
};
